import {ComponentType} from '@angular/cdk/overlay';
import {InjectionToken} from '@angular/core';
import {AdvanceFilterParamType, IAdvanceFilter, IAdvanceFilterComponent} from './components/advance-filter';

export interface IFilterChooserResult<T> {
    component: ComponentType<IAdvanceFilterComponent<T>>
    inputs?: Record<string, unknown>;
}

export interface IFilterChooser<T> {
    choose(item: IAdvanceFilter<T>): IFilterChooserResult<T>
}

export const IFilterChooserToken = new InjectionToken<IFilterChooser<AdvanceFilterParamType>>('IFilterChooserToken');
